import React from 'react';
import ReactDOM from "react-dom";
import { Timeline } from 'react-twitter-widgets';

const TwitterAtlantic = (props) => {
    if (props.source !== undefined) {
        return (
            <Timeline 
              dataSource={props.source.dataSource}
              options={props.source.options}
            />
        )
    }
    else {
        return <p>Loading...</p>
    }
    
}

ReactDOM.render((<TwitterAtlantic />), document.getElementById('root'));
export default TwitterAtlantic;


// WEBPACK FOOTER //
// ./src/components/TwitterAtlantic.js